/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { IUserSessionApiClient } from './contracts'
import { SettingsManager } from '../../configuration/SettingsManager'
import { injectable } from 'inversify'
import { ITokenResponse } from '../UserSessionStateManager/contracts'

const axios = require('axios').default

@injectable()
export class UserSessionApiClient implements IUserSessionApiClient {
	refreshSessionJwt(sessionJwt: string | null): Promise<ITokenResponse> {
		const refreshToken = localStorage.getItem(SettingsManager.REACT_APP_Refresh_TOKEN_NAME)
		return axios
			.get(`${SettingsManager.REACT_APP_USER_SESSION_API_BASE_URL().value}/auth/refresh`, {
				headers: {
					Authorization: 'Bearer ' + sessionJwt,
				},
				params: {
					refreshToken: refreshToken,
				},
			})
			.then((response: { data: any }) => {
				return response.data
			})
			.catch((error: any) => {
				console.error(`Request to refresh session failed. More information: ${JSON.stringify(error)}`)
				//throw new Error(`Error returned from attempt to authenticate: ${error.message}`)
				throw error
			})
	}
}
